import { useAxios } from "@hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useCompleteExamPeriod = () => {

    const axios = useAxios();
    const {t} = useTranslation();
    const queryClient = useQueryClient();

    const startExamPeriod = async (examPeriod: any) => {
        try {
            await axios.post(`/api/examterms/complete/${examPeriod.id}`);
        } catch (error) {
            throw new Error(t("messages.error.startExamPeriod"));
        }
    }

    return useMutation({ mutationFn: startExamPeriod, onSuccess: (_, variables) => {
        console.log(variables);
        
        queryClient.invalidateQueries({ queryKey: ["examPeriods"]});
    }});
}